'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.SilhouetteThumbnail = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Contact Thumbnail for the selected recipient
                                                                                                                                                                                                                                                                   * It will show the user's thumbnail || initials
                                                                                                                                                                                                                                                                   * thumbnailUrl will default to the blank gravatar image
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLES = {
	contactThumbnailImage: {
		height: '6em',
		width: '6em',
		position: 'absolute',
		top: 0,
		left: 0,
		border: '1px solid #9d9d9d',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		borderRadius: '50%'
	},

	contactThumbnailWrapper: {
		height: '6em',
		width: '6em',
		margin: '0 auto',
		position: 'relative',
		display: 'table',
		backgroundColor: '#ffffff',
		borderRadius: '50%'
	}
};

/**
 * If the contact doesn't already have a thumbnail or initials, render a generic user silhouette thumbnail
 */
var SilhouetteThumbnail = exports.SilhouetteThumbnail = function SilhouetteThumbnail(_ref) {
	var _ref$silhouetteStyleO = _ref.silhouetteStyleOverride,
	    silhouetteStyleOverride = _ref$silhouetteStyleO === undefined ? {} : _ref$silhouetteStyleO;

	var contact_outline = 'M50,55.1588865 L39.4561317,49.7443284 C38.7349027,49.3182858 38.2541838,48.6479178 38.0736505,47.7955272 L37.4726765,43.8976196 C38.9151346,42.5577997 40.0571057,40.7305505 40.8383116,38.599116 L42.2207928,37.8682774 C42.5812566,37.6856441 42.6180264,37.3203776 42.6783046,36.9548055 L43.3763265,31.4733633 L43.3763265,31.4125874 C43.3763265,31.2904246 43.6400438,31.1688727 43.6400438,31.0473208 C43.6400438,30.0724621 43.0203836,29.3419289 42.1788994,29.1592956 C42.3594328,27.3320464 42.7708317,24.103896 42.7708317,22.6425242 C42.4103679,17.7092872 40.8732729,16.7955099 34.6823972,13.5068889 C32.6392665,12.4715597 31.2694437,10.7053919 30.7887248,9 C21.652956,12.1670691 19.1951111,16.734734 18.8946241,22.4595855 C18.8346473,23.982344 19.1077077,27.270965 19.4081947,29.1592956 C18.5067337,29.3419289 17.7580781,30.1335435 17.7580781,31.0473208 L17.7580781,31.4125874 L17.7580781,31.4733633 L18.810536,36.9548055 C18.8705128,37.3203776 19.1863708,37.6856441 19.5468346,37.8682774 L21.0869434,38.8431361 C21.8684507,40.9134892 23.0480957,42.7364627 24.4905538,44.263497 L24.4305769,44.263497 L23.8293016,47.9784659 C23.7093479,48.8308565 23.2283276,49.4096025 22.4471217,49.8359504 L12,55.1729352 C17.1875446,59.4544339 23.8069986,62 31.019289,62 C38.213496,62 44.8178804,59.4211445 50,55.1588865';
	var contact_border = 'M52.0666968,53.0666968 C40.1557367,64.9777677 20.8442633,64.9777677 8.93330324,53.0666968 C-2.97776775,41.1557367 -2.97776775,21.8442633 8.93330324,9.93330324 C20.8442633,-1.97776775 40.1557367,-1.97776775 52.0666968,9.93330324 C63.9777677,21.8442633 63.9777677,41.1557367 52.0666968,53.0666968 Z';

	var style = { background: '#E1E7EB', borderRadius: '50%' };

	return _react2.default.createElement(
		'svg',
		{ width: '100%', height: '100%', viewBox: '2.5 2.5 62 62', style: Object.assign(style, silhouetteStyleOverride) },
		_react2.default.createElement(
			'g',
			{ fill: 'none', transform: 'translate(3.000000, 2.000000)' },
			_react2.default.createElement('path', { d: contact_outline, fill: 'rgba(255, 255, 255, 0.8)' }),
			_react2.default.createElement('path', { d: contact_border, stroke: '#E1E7EB', strokeLinecap: 'round' })
		)
	);
};
SilhouetteThumbnail.propTypes = {
	silhouetteStyleOverride: _react.PropTypes.object
};

var ContactThumbnail = _react2.default.createClass({
	displayName: 'ContactThumbnail',

	propTypes: {
		// these props are not currently being used, but may become necessary if we allow
		// users of the component to pass overriding class names through the root component
		// to fit their specific implementation (or we can disallow this)
		// ___
		wrapperClassName: _react.PropTypes.string,
		thumbnailClassName: _react.PropTypes.string,
		initialsClassName: _react.PropTypes.string,
		// __

		thumbnailUrl: _react.PropTypes.string.isRequired,
		thumbnailStyleOverride: _react.PropTypes.object,
		silhouetteStyleOverride: _react.PropTypes.object,
		initialsStyleOverride: _react.PropTypes.object,
		initials: _react.PropTypes.string
	},

	getDefaultProps: function getDefaultProps() {
		return {
			thumbnailUrl: ''
		};
	},
	render: function render() {
		var thumbnailUrl = this.props.thumbnailUrl;
		var hasInitials = !!this.props.initials;

		/**
   * show the silhouette if:
   * 1) the user can't use or doesn't have initials
   * 2) the user doesn't have a thumbnail or gravatar
   */
		var showSilhouette = !hasInitials && (!thumbnailUrl || thumbnailUrl.includes('d=blank'));
		var customStyle = this.props.thumbnailStyleOverride || {};
		var imageStyle = _extends({}, STYLES.contactThumbnailImage, customStyle, {
			backgroundImage: 'url(\'' + thumbnailUrl + '\')'
		});

		return _react2.default.createElement(
			'div',
			{ className: this.props.wrapperClassName, style: _extends({}, STYLES.contactThumbnailWrapper, customStyle) },
			_react2.default.createElement(
				'span',
				{ style: imageStyle, className: this.props.thumbnailClassName },
				showSilhouette && _react2.default.createElement(SilhouetteThumbnail, { silhouetteStyleOverride: this.props.silhouetteStyleOverride })
			),
			_react2.default.createElement(
				'span',
				{ className: this.props.initialsClassName,
					style: _extends({ display: 'table-cell', verticalAlign: 'middle', fontSize: 30 }, this.props.initialsStyleOverride) },
				this.props.initials
			)
		);
	}
});

exports.default = ContactThumbnail;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/ContactThumbnail.js
// module id = 399
// module chunks = 6